import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

// import { Roles } from '../../config'
import Loading from '../Loading'
import AppSettingsCompanyGeneral from './AppSettingsCompanyGeneral'
import AppSettingsCompanyUsers from './AppSettingsCompanyUsers'

import { Tabs, Button, Icon } from 'antd'
const TabPane = Tabs.TabPane

class AppSettingsCompany extends Component {
  render () {
    const { match: { params }, companies } = this.props

    if (!companies) return <Loading />

    const currentCompany = companies[params.companyId]

    return (
      <div>

        <h2>Edit Company: {currentCompany.name}</h2>

        <Link to={`/settings`}>
          <Button icon='left' style={{ position: 'absolute', right: 40, zIndex: 1 }}>
            Back to App Settings
          </Button>
        </Link>

        <Tabs type='card'>

          <TabPane tab={<span><Icon type='setting' />General</span>} key='general'>
            <AppSettingsCompanyGeneral company={currentCompany} />
          </TabPane>

          <TabPane tab={<span><Icon type='usergroup-add' />Company Users</span>} key='users'>
            <AppSettingsCompanyUsers company={currentCompany} />
          </TabPane>

        </Tabs>

      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  companies: state.companies
})

export default connect(mapStateToProps)(withRouter(AppSettingsCompany))



// WEBPACK FOOTER //
// ./src/components/AppSettings/AppSettingsCompany.js